import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FineTuneIcon from '../../svgs/finetune.svg';
import { FilterCourses, FilterCoursesProps } from './FilterCourses';

type FilterCoursesModalProps = Omit<FilterCoursesProps, 'onHide'> & { isLoading: boolean };

const FilterCoursesModal: React.FC<FilterCoursesModalProps> = ({ isLoading, ...filterProps }) => {
    const [show, setShow] = React.useState(false);

    return (
        <>
            {!isLoading && (
                <Button
                    className="border-0 p-0 search-filter-sort text-decoration-none"
                    onClick={() => setShow(true)}
                    variant="link"
                >
                    <FineTuneIcon className="align-text-top mr-1 size-4" />
                    Filter Results
                </Button>
            )}

            <Modal
                className="p-0"
                contentClassName="bg-light h-100 mh-100"
                dialogClassName="h-100 mh-100 m-0 mw-100"
                onHide={() => setShow(false)}
                scrollable
                show={show}
            >
                <Modal.Body>
                    <FilterCourses {...filterProps} onHide={() => setShow(false)} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export { FilterCoursesModal, FilterCoursesModalProps };
